import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'
import Product from '@/views/ProductDesc'
import About from '@/views/AboutUs'
import Help from '@/views/HelpCenter'
import Error404 from '@/views/Error404'
import Error500 from '@/views/Error500'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    }, {
      path: '/product',
      name: 'Product',
      component: Product
    }, {
      path: '/about',
      name: 'About',
      component: About
    }, {
      path: '/help',
      name: 'Help',
      component: Help
    }, {
      path: '/500',
      name: 'Error500',
      component: Error500
    }, {
      path: '/404',
      name: 'Error404',
      component: Error404
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js